import { render, staticRenderFns } from "./StreamOwnerPayments.vue?vue&type=template&id=3b97e432&"
import script from "./StreamOwnerPayments.vue?vue&type=script&lang=ts&"
export * from "./StreamOwnerPayments.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports